<template>
    <van-tabbar v-model="active" inactive-color="#666666" active-color="#000000" fixed placeholder>
      <van-tabbar-item replace v-for="(item, index) in tabbarList" :key="index"  @click.native="userInfoEdit(item.path)">
        <span>{{ item.title }}</span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.active : item.normal" />
      </van-tabbar-item>
    </van-tabbar>
</template>

<script>
import { mapState,mapActions } from 'vuex'
export default {
  name: "page-tabbar",
  data() {
    return {
      active: 0,
      tabbarList: [
        {
          path: "/home",
          title: "首页",
          normal: "https://style.81lianpin.com/img/icon1_inactive.png",
          active: "https://style.81lianpin.com/img/icon1_active.png",
        },
        {
          path: "/myCourses",
          title: "我的课程",
          normal: "https://style.81lianpin.com/img/icon2_inactive.png",
          active: "https://style.81lianpin.com/img/icon2_active.png",
        },
        {
          path: "/mine",
          title: "我的",
          normal: "https://style.81lianpin.com/img/icon3_inactive.png",
          active: "https://style.81lianpin.com/img/icon3_active.png",
        },
      ],
    };
  },
 computed: {
    ...mapState(['appid', 'stylePath','publicPath'])
  },
  created() {
    if(this.$route.params.id || this.$route.query.arrondiId) {
      this.arrondiId = this.$route.params.id? this.$route.params.id : this.$route.query.arrondiId
    } else {
      this.arrondiId = ''
    }
  },
  //监听路由变化
  watch: {
    $route(to) {
      if(this.$route.params.id || this.$route.query.arrondiId) {
        this.active = 0
      }
      // this.active = 0
      this.activeTab(to.path);
    },
  },

  methods: {
    activeTab(path) {
      var index = this.tabbarList.map((item) => item.path).indexOf(path);
      if (index != -1) {
        this.active = index;
      }
    },
    userInfoEdit(url) {
      console.log(this.$route.params.id || this.$route.query.arrondiId);
      console.log(this.$route.params.id);
      console.log(this.$route.query.arrondiId);
      if(this.$route.params.id || this.$route.query.arrondiId) {
        this.arrondiId = this.$route.params.id? this.$route.params.id : this.$route.query.arrondiId
      } else {
        this.arrondiId = ''
      }
      // console.log(this.$route.meta.homeUrl);
      let vm = this
      if(url == "/home"){
        this.active = 0
        this.actUrl =""
         this.$router.push({ path:  this.arrondiId? '/arrondi/' + this.arrondiId : '/home'})
      }else if(url == "/myCourses"){
        if(this.$route.path ==='/mine'){
          this.active = 2
        }else  if(this.$route.path ==='/home'){
          this.active = 0
        }
        vm.$store.dispatch('hasInfo').then(res => {
          this.$router.push({ path: url,query: {arrondiId: this.arrondiId} })
          this.active = 1
        })
      }else{
        this.$router.push({ path: url,query: {arrondiId: this.arrondiId}})
      }
    },
  },
  mounted() {
    this.activeTab(this.$route.path);
  },
};
</script>

<style scoped>
a {
  color: #000;
}
.van-tabbar{

}
.mint-tabbar {
  border-top: 1px solid #ccc;
}
.mint-tabbar a {
  display: flex;
  justify-content: space-around;
}
.mint-tabbar .mint-tab-item {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/TabBar.vue